<template>
  <v-theme-provider dark>
    <base-section id="info-alt" class="grey darken-4">
      <v-responsive class="mx-auto" max-width="1400">
        <v-container fluid>
          <v-row>
            <v-col cols="12" md="3">
              <v-theme-provider>
                <!-- <v-theme-provider :dark="dark"> -->
                <div>
                  <base-img
                    :src="require('@/assets/logo.png')"
                    contain
                    max-width="200"
                    width="100%"
                    class="pb-6"
                  />

                  <a
                    :text="'About Us'"
                    class="mb-8 grey--text text-size d-block text-none"
                    href="#"
                    v-html="'&rsaquo; About Us'"
                  />

                  <a
                    :text="'Privacy Policy'"
                    class="mb-8 grey--text text-size d-block text-none"
                    href="/privacy"
                    v-html="'&rsaquo; Privacy Policy'"
                  />

                  <a
                    :text="'Terms & Conditions'"
                    class="mb-8 grey--text text-size d-block text-none"
                    href="/terms"
                    v-html="'&rsaquo; Terms & Conditions'"
                  />

                  <a
                    :text="'Blogs'"
                    class="mb-8 grey--text text-size d-block text-none"
                    href="/blogs"
                    v-html="'&rsaquo; Blogs'"
                  />
                  
                  <a
                    class="mb-8 grey--text text-size d-block text-none"
                    href="#"
                    v-html="'Copyright © 2020'"
                  />
                </div>
              </v-theme-provider>
            </v-col>

            <v-col cols="12" md="2">
              <base-info-card title="Shippers">
                <a
                  :text="'Sign Up'"
                  class="mb-8 grey--text text-size d-block text-none"
                  href="#"
                  v-html="'&rsaquo; Sign Up'"
                />
                <a
                  :text="'Why Us ?'"
                  class="mb-8 grey--text text-size d-block text-none"
                  href="#"
                  v-html="'&rsaquo; Why Us ?'"
                />
                <a
                  :text="'Pricing'"
                  class="mb-8 grey--text text-size d-block text-none"
                  href="#"
                  v-html="'&rsaquo; Pricing'"
                />
                <a
                  :text="'Terms & Condition'"
                  class="mb-8 grey--text text-size d-block text-none"
                  href="#"
                  v-html="'&rsaquo; Terms & Condition'"
                />
                <a
                  text
                  small
                  class="mb-8 grey--text text-size d-block text-none"
                  :href="'/reach-us'"
                  v-html="'&rsaquo; Reach Us'"
                />
              </base-info-card>
            </v-col>

            <v-col cols="12" md="2">
              <base-info-card title="Shippers">
                <a
                  :text="'Sign Up'"
                  class="mb-8 grey--text text-size d-block text-none"
                  href="#"
                  v-html="'&rsaquo; Sign Up'"
                />
                <a
                  :text="'Why Us ?'"
                  class="mb-8 grey--text text-size d-block text-none"
                  href="#"
                  v-html="'&rsaquo; Why Us ?'"
                />
                <a
                  :text="'Pricing'"
                  class="mb-8 grey--text text-size d-block text-none"
                  href="#"
                  v-html="'&rsaquo; Pricing'"
                />
                <a
                  :text="'Terms & Condition'"
                  class="mb-8 grey--text text-size d-block text-none"
                  href="#"
                  v-html="'&rsaquo; Terms & Condition'"
                />
                <a
                  text
                  small
                  class="mb-8 grey--text text-size d-block text-none"
                  :href="'/reach-us'"
                  v-html="'&rsaquo; Reach Us'"
                />
              </base-info-card>
            </v-col>

            <v-col cols="12" md="2">
              <base-info-card title="Get The App">
                <base-img
                  :src="require('@/assets/app_store.png')"
                  contain
                  max-width="120"
                  width="100%"
                  class="pb-6"
                />
                <a
                  href="https://play.google.com/store/apps/details?id=com.doship"
                  target="_black"
                >
                  <base-img
                    :src="require('@/assets/google_play.png')"
                    contain
                    max-width="120"
                    width="100%"
                    class="pb-6"
                  />
                </a>
              </base-info-card>
            </v-col>

            <v-col cols="12" md="3">
              <base-info-card title="Contact" />
              <base-business-contact dense />
            </v-col>
          </v-row>
        </v-container>
      </v-responsive>
    </base-section>
  </v-theme-provider>
</template>

<script>
export default {
  name: "SectionBusinessInfo",
};
</script>

<style lang="sass">
#info-alt a
  text-decoration: none

.text-size
  font-size: 16px !important
</style>
